import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import OnboardingOptions from './components/OnboardingOptions';
import CompletionScreen from './components/CompletionScreen';
import ImageSelection from './components/ImageSelection';
import Translation from './components/Translation';  // Assuming we have the Translation component already
import MatchingPairs from './components/MatchingPairs';  
import LearningFlow from './components/LearningFlow';  
import Practice from './components/Practice';  



function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<OnboardingOptions />} />
        <Route path="/image-selection" element={<ImageSelection />} />
        <Route path="/translation" element={<Translation />} />  
        <Route path="/matching-pairs" element={<MatchingPairs />} />
        <Route path="/completion" element={<CompletionScreen />} />
        <Route path="/learning-flow" element={<LearningFlow />} />
        <Route path="/practice" element={<Practice />} />


        
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
